document.addEventListener("DOMContentLoaded", function () {
  const container = document.createElement("div");
  container.id = "chatbot-widget";
  container.style.cssText = `
    position: fixed; bottom: 20px; right: 20px;
    width: 300px; height: 400px; background: white;
    border: 1px solid #ddd; border-radius: 10px;
    display: flex; flex-direction: column;justify-content: end;
    box-shadow: 0 4px 10px rgba(0,0,0,0.2);
    font-family: sans-serif; z-index: 9999; display:none;
  `;

  container.innerHTML = `
    <div id="chatbot-header" style="background:#1c2228; color:white; padding:8px; display:flex; justify-content:space-between; align-items:center;">
      <span>Quickly 🤖</span>
      <button id="chatbot-close" style="background:none; border:none; color:white; font-size:16px; cursor:pointer;">−</button>
    </div>
    <div id="chatbot-messages" style="flex:1; padding:10px; overflow:auto;"></div>
    <div style="display:flex; border-top:1px solid #ddd;">
      <input type="text" id="chatbot-input" placeholder="Type a message..."
        style="flex:1; padding:8px; border:none; outline:none;" />
      <button id="chatbot-send"
        style="padding:8px; border:none; background:#007bff; color:#fff;">Send</button>
    </div>
  `;

  // Floating icon
  const icon = document.createElement("div");
  icon.id = "chatbot-icon";
  icon.style.cssText = `
    position: fixed; bottom: 20px; right: 20px;
    width: 60px; height: 60px; border-radius: 50%;
    background: #2d343b; display:flex; align-items:center; justify-content:center;
    color: white; font-size:24px; cursor:pointer;
    box-shadow: 0 4px 10px rgba(0,0,0,0.3); z-index:9999;
  `;
  icon.innerHTML = "🤖";

  document.body.appendChild(icon);
  document.body.appendChild(container);

  const input = document.getElementById("chatbot-input");
  const messagesDiv = document.getElementById("chatbot-messages");
  const sendBtn = document.getElementById("chatbot-send");
  const closeBtn = document.getElementById("chatbot-close");

  // Open chat and show greeting
  icon.addEventListener("click", () => {
    container.style.display = "flex";
    icon.style.display = "none";

    // Only greet once
    if (!messagesDiv.dataset.greeted) {
messagesDiv.innerHTML += `
  <div>
    <b>Quickly:</b> أهلاً بيك! أنا Quickly، مساعدك الشخصي 👋<br/>
    تحب تعرف إيه العطر الأنسب لشخصيتك؟ 
    جرب اختبار <i>Personality Notes</i> 
    من هنا 👉 
    <a href="https://wf.engkhalednabil.com/form/personality-test" target="_blank">
      اضغط هنا
    </a>
    وهقولك النوتة المناسبة ليك 🎉
  </div>
`;
      messagesDiv.dataset.greeted = "true";
    }
  });

  closeBtn.addEventListener("click", () => {
    container.style.display = "none";
    icon.style.display = "flex";
  });

  async function sendMessage() {
    const userMessage = input.value.trim();
    if (!userMessage) return;

    messagesDiv.innerHTML += `<div><b>You:</b> ${userMessage}</div>`;
    input.value = "";

    // Show "thinking..."
    const thinkingDiv = document.createElement("div");
    thinkingDiv.innerHTML = `<b>Quickly:</b> <span style="color:gray;">thinking...</span>`;
    messagesDiv.appendChild(thinkingDiv);
    messagesDiv.scrollTop = messagesDiv.scrollHeight;

    try {
      const response = await fetch("https://wf.engkhalednabil.com/webhook/3e796c2e-5096-4fcf-96cd-47dce56c8ec6", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ message: userMessage })
      });

      const data = await response.json();
      thinkingDiv.remove();
      messagesDiv.innerHTML += `<div><b>Quickly:</b> ${data.reply}</div>`;
    } catch (e) {
      thinkingDiv.remove();
      messagesDiv.innerHTML += `<div style="color:red;"><b>Quickly:</b> Sorry, something went wrong.</div>`;
    }

    messagesDiv.scrollTop = messagesDiv.scrollHeight;
  }

  sendBtn.addEventListener("click", sendMessage);
  input.addEventListener("keypress", e => { if (e.key === "Enter") sendMessage(); });
});
